import Anotacoes from '@mui/icons-material/Notes';
import { makeObservable, observable } from 'mobx';

import { Filtro } from './Filtro';

export default class FiltroAnotacoes extends Filtro {
    tipo = 'booleano';

    exibicao = 'checkbox';

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            tipo: true,
            exibicao: true,
            label: true,
            getIconeFiltroRapido: true,
            getValorOpcao: true,
            getDescricao: true,
            filtroRapido: observable
        });
    }

    get label() {
        return 'Com anotações (curtas ou complementares)';
    }

    getIconeFiltroRapido() {
        return <Anotacoes />;
    }

    getValorOpcao(registro) {
        return (
            registro.informacaoProcessoSalaSessao &&
            (registro.informacaoProcessoSalaSessao.anotacao ||
                registro.informacaoProcessoSalaSessao.complementoAnotacoes)
        );
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
